import { render, staticRenderFns } from "./ResetPwView.vue?vue&type=template&id=8ea011c6"
import script from "./ResetPwView.vue?vue&type=script&lang=js"
export * from "./ResetPwView.vue?vue&type=script&lang=js"
import style0 from "./ResetPwView.vue?vue&type=style&index=0&id=8ea011c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports